import Modal from "../../common/Modal";
import './NewBreadOrderNotification.css';


export default function NewBreadOrderNotification({ newOrders, setShowModal }) {
    function handleClose() {
        setShowModal(false);
    }

    return (
       <Modal onClose={handleClose} >
            <div className="notif-title">🗓️ Panes Para Hoy 🗓️</div>
            {newOrders.map((order) => (
                <div key={order.id} className="new-order-notification">
                       <p className="customer-name">{order.firstName} {order.lastName}</p>
                       <p className="new-order-notification-bread-name">Hora: {order.time}</p>
                    <div className="bread-tag-container">
                    {order.bread.map((bread) => (
                       
                            <div className="bread-tag">{bread.quantity} {bread.bread}</div>
                        
                    ))}
                    </div>
                </div>
            ))}
       </Modal>
    );
}